var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "login-page-container",
        {
          "sub-option":
            _vm.$route.name === "register" ||
            _vm.$route.name === "sign-in" ||
            _vm.$route.name === "forgot-password"
        },
        { central: _vm.$route.path.includes("forgot-password") }
      ]
    },
    [
      _c("div", { staticClass: "login-image-container" }, [
        _c("img", {
          ref: "image",
          attrs: {
            src: _vm.isDesktopDevice ? _vm.vector : _vm.mobile,
            alt: "vector"
          }
        }),
        _c("div", { ref: "hover", staticClass: "hover" })
      ]),
      _c(
        "div",
        { staticClass: "content-login" },
        [
          _c("h1", [
            _vm._v("Welcome to Akkodis DRC-GOP Sales-Enablement Platforms")
          ]),
          _c(
            "transition",
            {
              attrs: {
                mode: _vm.currentTransition.mode,
                name: _vm.currentTransition.name,
                duration: _vm.currentTransition.duration
              }
            },
            [_c("router-view", { staticClass: "login-page-content" })],
            1
          )
        ],
        1
      ),
      _c("HelperButton", {
        attrs: {
          hasResources: false,
          hasContactCmt: false,
          hasReportAProblem: false
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }